export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/app.Message.worker.d28f0b3ffb81886e15aa.worker.js");
}
